// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"108c8b7b","318":"e8609dc1","995":"d3f1a66e"}[chunkId] + ".chunk.js";
};